import React, {useCallback, useState} from 'react';
import {Button, Input, Layout, Spacer, Text} from '@di-nxt/components';
import {Screen} from '../../components';
import {t} from '../../localization';
import {useAuthenticate} from '../../services';

export const LoginScene: React.FC = () => {
  const [username, setUsername] = useState<string>();
  const [password, setPassword] = useState<string>();
  const [error, setError] = useState<string>();

  const handleUpdateUsername = useCallback((t: string) => setUsername(t), []);
  const handleUpdatePassword = useCallback((t: string) => setPassword(t), []);

  const authenticate = useAuthenticate();
  const handleLogin = useCallback(() => {
    if (username && password) {
      return new Promise<void>((resolve, reject) => {
        setError(undefined);
        authenticate(username, password)
          .then(result => {
            setTimeout(() => {
              console.log(result.accessToken);
              resolve();
            }, 500);
          })
          .catch(err => {
            setTimeout(() => {
              setError(err);
              reject(err);
            }, 500);
          });
      });
    }
  }, [password, username, authenticate]);

  return (
    <Screen>
      <Layout centered flex>
        <Layout vertical width={360}>
          <Text variant="inline_24_emphasis">{t('screens.login.title')}</Text>
          <Spacer height={'56'} />
          <Text variant="paragraph_14_emphasis">
            {t('screens.login.email')}
          </Text>
          <Spacer height="10" />
          <Input onChange={handleUpdateUsername} />
          <Spacer height="20" />
          <Text variant="paragraph_14_emphasis">
            {t('screens.login.password')}
          </Text>
          <Spacer height="10" />
          <Input onChange={handleUpdatePassword} secure />
          <Spacer height="20" />
          {error && <Text>{JSON.stringify(error)}</Text>}
          <Button
            kind="Primary"
            state={username && password ? 'Default' : 'Disabled'}
            title={t('screens.login.loginbtn')}
            onPress={handleLogin}
            inline
            size="Large"
          />
        </Layout>
      </Layout>
    </Screen>
  );
};
